import config from '@/config';

import { useEffect, useState } from 'react';

import {
  type ContentfulConnectorEntry,
  fetchContentfulConnectors,
} from '../api/contentfulConnectors';

interface UseContentfulConnectorsResult {
  connectors: ContentfulConnectorEntry[];
  isLoading: boolean;
  error: Error | null;
}

/**
 * Fetches connectors from Contentful - matches dataProtect ConnectorBar.js
 * Uses config.IS_INTEGRATION for forIntegrationOnly filter (prod hides integration-only connectors)
 */
export const useContentfulConnectors = (): UseContentfulConnectorsResult => {
  const [connectors, setConnectors] = useState<ContentfulConnectorEntry[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let cancelled = false;
    const isIntegration = Boolean((config as { IS_INTEGRATION?: boolean }).IS_INTEGRATION);

    fetchContentfulConnectors(isIntegration)
      .then((result) => {
        if (!cancelled) {
          setConnectors(result);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err instanceof Error ? err : new Error(String(err)));
          setConnectors([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { connectors, isLoading, error };
};
